import React from 'react';

const TermsOfUse = () => {
  return (
    <div className='lg:pt-[168px] pt-[140px] lg:pb-[120px] pb-12 lg:px-20 md:px-10 px-4'>
      <div className='w-full max-w-[845px]'>
        <p className='lg:text-[48px] text-[32px] text-l-primary font-bold'>
          Terms of Use
        </p>
        <p className='text-base font-semibold text-l-red mt-2'>
          Please read the Terms of Use carefully before engaging with Legal
          Avenue.
        </p>
        <p className='text-base text-l-primary mt-8 font-semibold'>
          These Terms of Use ("Terms") govern your access to and use of the
          Legal Avenue website (the "Website"), mobile application (the "App"),
          and all associated services, features, and content offered by Legal
          Avenue (collectively, the "Services"). In these Terms of Use, the
          words “you” and “your” refer to each customer, Site visitor, or App
          user, “we”, “us” and “our” refer to Legal Avenue, and “Services”
          refers to all services provided by us.
        </p>
        <p className='text-base text-l-primary mt-5'>
          By accessing or using the Services, you agree to be bound by and
          comply with these Terms. If you disagree with any part of these Terms,
          you may not access or use the Services.
        </p>
        <p className='text-base text-l-primary mt-5'>
          It is your responsibility to review these Terms of Use periodically.
          If you find these Terms unacceptable or do not agree with any of these
          Terms, please do not use our Website, App, or Services. We reserve the
          right to change, modify, or revise these Terms at our sole discretion.
          If you have any questions about the Terms of Use, please contact us at
          info@legalavenue.pk.
        </p>
        <p className='text-base text-l-primary mt-5'>
          BY USING OUR WEBSITE, APP, AND/OR SERVICES, YOU AGREE THAT YOU ARE AT
          LEAST 18 YEARS OLD AND LEGALLY ELIGIBLE TO ENTER INTO A CONTRACT
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Client-Attorney Relationship
        </p>
        <p className='text-base text-l-primary mt-4'>
          The Legal Avenue Website and App does not intend to create any
          client-attorney relationships. Your use of Legal Avenue will not
          create any attorney-client relationships between you and Legal Avenue.
          When you hire a lawyer on Legal Avenue, you are solely responsible to
          represent yourself in any legal matters you are involved in.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Privacy Policy
        </p>
        <p className='text-base text-l-primary mt-4'>
          Legal Avenue values your privacy and allows you to control our
          treatment of your information. We have a detailed Privacy Policy that
          explains how we use, share, and disclose your information. You can
          review our Privacy Policy here (Link).
        </p>
        <p className='text-base text-l-primary mt-4'>
          When you register on the Legal Avenue Website or App, it’s your
          responsibility to provide complete and accurate information. You are
          also responsible for keeping your personal information such as
          username and password confidential. You can not use any third-party’s
          account, username, or password at any time. If someone else uses your
          account, username, or password, Legal Avenue will not be responsible
          for any losses in that case. If you find any unauthorized use of your
          account, you must notify us immediately.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Ownership
        </p>
        <p className='text-base text-l-primary mt-4'>
          This Website and our App are owned and operated by Legal Avenue. All
          the materials you see on this Website and App, including but not
          limited to, text, graphics, logos, images, sounds, and information are
          the property of Legal Avenue.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Restriction to Use
        </p>
        <p className='text-base text-l-primary mt-4'>
          Unless Legal Avenue explicitly mentions, you can not use any of the
          materials owned and displayed on this Website and App. You can not
          copy, reproduce, post, download, upload, display, or transmit any
          materials in any way without Legal Avenue’s permission.
        </p>
        <p className='text-base text-l-primary mt-4'>
          You simply can not gain the right to ownership of these Materials. We
          do not grant any licenses to our intellectual property through your
          use of the Website, App, and Services.
        </p>
        <p className='text-base text-l-primary mt-4'>
          Legal Avenue does not sell, trade, license, lease, or provide any
          Materials other than those specifically identified as Legal Avenue’s
          property.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Intellectual Property Laws
        </p>
        <p className='text-base text-l-primary mt-4'>
          Legal Avenue is committed to protecting intellectual property rights.
          When you access our Website, App, or use our Services, you agree to:
        </p>
        <p className='text-base text-l-primary mt-5 relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[50%] before:bg-l-primary  pl-3'>
          Follow all copyright, trademark, and other intellectual property
          laws. 
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          Not upload, download, or share content that infringes on someone
          else's intellectual property.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Consequences of Violation
        </p>
        <p className='text-base text-l-primary mt-4'>
          Legal Avenue has a zero-tolerance policy for intellectual property
          infringement. This means we will immediately remove any content that
          violates these terms, whether it belongs to Legal Avenue or a third
          party. If Legal Avenue suspects intellectual property infringement, we
          will:
        </p>
        <p className='text-base text-l-primary mt-5 relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          Remove the Infringing Content: The content will be taken down from the
          Website or App.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          Investigate the Claim: We will look into the allegation of
          infringement immediately.
        </p>
        <p className='text-base text-l-primary mt-4'>
          <span className='font-semibold'>Remember:</span> You are responsible
          for ensuring any content you upload or share through Legal Avenue
          doesn't violate intellectual property rights.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Copyrights
        </p>
        <p className='text-base text-l-primary mt-4'>
          Legal Avenue respects the intellectual property of others and expects
          the same from its users. Copyright protects original creative works,
          such as text, images, and software.
        </p>
        <p className='text-base text-l-primary mt-5 relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          You cannot upload, download, display, perform, transmit, or distribute
          any content that infringes on a third party's copyright.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          This includes things like copying and pasting someone else's work
          without permission or using copyrighted material without proper
          licensing.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          You are solely responsible for any violations of copyright laws and
          infringements caused by content you provide or transmit through Legal
          Avenue.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          You need to ensure you have the right to use any content you share on
          the platform.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Reporting Infringements
        </p>
        <p className='text-base text-l-primary mt-4'>
          If you suspect someone has infringed on your copyright through Legal
          Avenue, you'll need to submit a formal takedown notice. This notice
          must include the following information:
        </p>
        <p className='text-base text-l-primary mt-5 relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Authorized Signature:</span> A
          physical or electronic signature from someone authorized to act on
          behalf of the copyright owner.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Identification of Your Work:</span>{' '}
          Clearly identify the specific copyrighted work that has been
          infringed.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>
            Identification of the Infringing Material:
          </span>{' '}
          Specify the content on Legal Avenue that you believe violates your
          copyright. Provide enough detail to help us locate the material (e.g.,
          URL, document title).
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Your Contact Information:</span>{' '}
          Include your address, phone number, and email address so we can reach
          you regarding the complaint.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Good Faith Belief:</span> State that
          you have a good faith belief that the material is being used without
          your permission or legal authorization.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Third Party Links
        </p>
        <p className='text-base text-l-primary mt-4'>
          Legal Avenue Website and App may have links to Third Party websites.
          Legal Avenue does not control these Third Party websites and is not
          responsible for their content, products, services, or availability.
          Here’s what you need to know about Third Party Links:
        </p>
        <p className='text-base text-l-primary mt-5 relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>For your convenience only:</span>{' '}
          Legal Avenue provides these links as a courtesy, not as an endorsement
          of the Third Party websites.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>No responsibility for content:</span>{' '}
          Legal Avenue is not responsible for the accuracy or quality of
          information or services offered on Third Party websites.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Use at your own risk:</span> You are
          responsible for any risks associated with visiting or using Third
          Party websites.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Contact the Third Party Site:</span>{' '}
          If you have any concerns about a Third Party website, please contact
          its administrator directly.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Dispute Resolution
        </p>
        <p className='text-base text-l-primary mt-4'>
          We strive to provide excellent service, but disagreements may arise.
          This section outlines how we will resolve disputes between you and
          Legal Avenue.
        </p>
        <p className='text-base text-l-primary mt-5 relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Informal Resolution:</span> We
          encourage you to contact us directly to try to resolve any disputes
          informally.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Binding Arbitration:</span> If we
          cannot reach an informal resolution, you and Legal Avenue agree to
          resolve any disputes through binding arbitration on an individual
          basis. This means we will present our case to a neutral arbitrator,
          instead of a judge or jury in court. The arbitrator's decision will be
          final and binding on both parties.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Exceptions to Arbitration:</span> This
          arbitration agreement does not apply to small claims matters that may
          be appropriate for filing in a small claims court.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Class Action Waiver:</span> You and
          Legal Avenue agree to waive the right to participate in a class action
          lawsuit or class arbitration.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Right to Opt Out:</span> You have the
          right to opt out of this arbitration agreement within 30 days of
          agreeing to these Terms of Use. You can opt out by sending an email to
          [Insert Email Address] with the subject line "Opt Out of Arbitration."
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Additional Terms
        </p>
        <p className='text-base text-l-primary mt-4'>
          Some Services offered by Legal Avenue may be subject to additional
          terms & conditions, guidelines, and rules. Your use of such Services
          is conditioned by your agreement with Additional Terms.
        </p>
        <p className='text-base text-l-primary mt-4'>
          IN CASE OF ANY CONFLICT BETWEEN TERMS OF USE AND ADDITIONAL TERMS, THE
          ADDITIONAL TERMS WILL BE EFFECTIVE FOR THAT SERVICE UNLESS EXPRESSED
          OTHERWISE.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          User-Generated Content (UGC)
        </p>
        <p className='text-base text-l-primary mt-4'>
          Legal Avenue may allow users to submit reviews, comments, and other
          communications ("User Content") on its Website, App, or other
          platforms. You are responsible for the content you submit and agree to
          the following:
        </p>
        <p className='text-base text-l-primary mt-5 relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>No Illegal Content:</span> You will
          not submit User Content that is illegal, hateful, discriminatory,
          threatening, defamatory, obscene, or violates the privacy of others.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Accuracy:</span> You will only submit
          User Content that is true and accurate to the best of your knowledge.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Ownership:</span> You represent and
          warrant that you own all rights to the User Content you submit or have
          the necessary permissions to grant us the rights outlined below.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>License:</span> By submitting User
          Content, you grant Legal Avenue a non-exclusive, irrevocable,
          royalty-free, worldwide license to use, reproduce, modify, publish,
          translate, distribute, and display your User Content on the Services
          and in connection with our marketing and promotional materials.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Monitoring:</span> Legal Avenue
          reserves the right, but does not have the obligation, to monitor User
          Content and may remove any content at its sole discretion.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          No Warranty
        </p>
        <p className='text-base text-l-primary mt-4'>
          LEGAL AVENUE PROVIDES THE WEBSITE, APP, AND ALL MATERIALS, DOCUMENTS,
          OR FORMS OFFERED BY US "AS IS" AND "AS AVAILABLE." THIS MEANS WE DON'T
          MAKE ANY GUARANTEES ABOUT THEIR FUNCTIONALITY OR SUITABILITY FOR YOUR
          NEEDS.
        </p>
        <p className='text-base text-l-primary mt-4 font-semibold'>
          We Don't Guarantee To:
        </p>
        <p className='text-base text-l-primary mt-5 relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Meeting Your Needs:</span> The
          Website, App, and Materials might not be exactly what you're looking
          for.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Uninterrupted Service:</span> There
          could be downtime or technical issues that prevent access.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Accuracy or Reliability:</span> The
          information provided may not always be accurate or perfectly reliable.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Quality of Results:</span> We cannot
          guarantee the outcome of using the materials or documents.
        </p>
        <p className='text-base text-l-primary mt-4'>
          BY USING LEGAL AVENUE, YOU ACKNOWLEDGE THESE LIMITATIONS AND TAKE FULL
          RESPONSIBILITY FOR ANY RISKS INVOLVED. WE WON'T BE LIABLE FOR ANY
          DAMAGE TO YOUR COMPUTER SYSTEM OR DATA LOSS CAUSED BY DOWNLOADING
          MATERIALS FROM OUR PLATFORM.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Liability and Indemnification
        </p>
        <p className='text-base text-l-primary mt-4'>
          Legal Avenue strives to provide excellent service, but there's always
          a chance something might go wrong. This section outlines the extent of
          our liability in such cases.
        </p>
        <p className='text-base text-l-primary mt-4 font-semibold'>
          We Are Not Liable For:
        </p>
        <p className='text-base text-l-primary mt-5 relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>
            Indirect, Punitive, or Consequential Damages:
          </span>{' '}
          This includes things like legal fees, lost business profits, or
          emotional distress, even if we were aware these risks were possible.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>
            Personal Injury or Property Damage:
          </span>{' '}
          This clause may not apply in all states.
        </p>

        <p className='text-base text-l-primary mt-4 font-semibold'>
          Extent of Our Liability:
        </p>
        <p className='text-base text-l-primary mt-5 relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>Limited to Paid Fees:</span> In most
          cases, our maximum liability will be limited to the amount you paid
          for our services.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          <span className='font-semibold'>No Punitive Damages:</span> We will
          not be liable for punitive damages (extra penalties imposed to punish
          the company).
        </p>
        <p className='text-base text-l-primary mt-4 font-semibold'>
          Important Note:
        </p>
        <p className='text-base text-l-primary mt-5 relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          Some states have different laws regarding limitations of liability.
          This clause may not apply in its entirety depending on your location.
        </p>
        <p className='text-base text-l-primary relative before:content-[""] before:size-1 before:rounded-full before:absolute  before:left-0 before:top-[9px] before:bg-l-primary  pl-3'>
          This paragraph does not apply to North Carolina consumers (due to
          specific state laws).
        </p>

        <p className='text-base text-l-primary mt-4'>
          We take responsibility for our services, but our liability is limited.
          It's important to understand these limitations before using Legal
          Avenue.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Inappropriate Content
        </p>
        <p className='text-base text-l-primary mt-4'>
          To maintain a professional and respectful environment, Legal Avenue
          prohibits you from uploading or sharing any content that is political,
          libelous, defamatory, obscene, pornographic, abusive, threatening, or
          promotes illegal activity. This also includes using the platform for
          solicitation purposes, such as advertising, fundraising, or soliciting
          goods or services. Legal Avenue reserves the right to remove any
          violating content and cooperate with law enforcement if necessary. By
          using Legal Avenue, you agree to be responsible for the content you
          contribute and to help us maintain a positive online community.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Trademarks
        </p>
        <p className='text-base text-l-primary mt-4'>
          Legal Avenue takes reasonable measures to protect trademarks and
          intellectual property. Our users are prohibited from uploading or
          using content that infringes on the trademarks of others, including
          logos, brand names, or other protected elements. Similarly, the Legal
          Avenue name, logo, and branding are trademarks and cannot be used
          without our permission.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Right to Refuse
        </p>
        <p className='text-base text-l-primary mt-4'>
          Legal Avenue reserves the right to refuse service to, and/or terminate
          user access of users who violate the Terms of Use or engage in
          inappropriate behavior.
        </p>
        <p className='text-[32px] text-l-primary font-semibold mt-8'>
          Acknowledgement
        </p>
        <p className='text-base text-l-primary mt-4'>
          By accessing our Website, App, or Services, you acknowledge and agree
          to be bound by these Terms of Use. This means you have read and
          understood the terms, confirm you are at least 18 (or the legal age in
          your area), and agree to comply with all the laws and regulations
          while using the platform. You are also solely responsible for your
          activity and any information you provide.
        </p>
      </div>
    </div>
  );
};

export default TermsOfUse;
